import Swiper, { Navigation, Keyboard, Pagination } from 'swiper'
Swiper.use([Navigation, Keyboard, Pagination])

class TimelineSlider {
  constructor() {
    this.timelineEl = document.getElementById('timeline')
    this.navigationLinks = [...this.timelineEl.querySelectorAll('[data-go-to-year]')]
    this.sliderEl = this.timelineEl.querySelector('.swiper')
    this.slider

    this.init()
    this.initSlideTo()

  }

  init() {
    this.slider = new Swiper(this.sliderEl, {
      slidesPerView: 'auto',
      // Disable preloading of all images
      spaceBetween: 0,
      loop: false,
      slideToClickedSlide: false,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      pagination: {
        el: '.timeline__pagination',
        type: "fraction",
        currentClass: 'timeline__current-index',
        formatFractionCurrent: number => `${number}`.padStart(2, '0'),
        formatFractionTotal: number => `${number}`.padStart(2, '0'),
      },
      navigation: {
        prevEl: '.timeline__button--prev',
        nextEl: '.timeline__button--next',
      }
    })
  }

  initSlideTo() {

    this.navigationLinks.map(link => {
      // find matching slide:
      const gotToYear = link.dataset.goToYear

      // use filter check for the next best match
      const firstMachingSliderIndex = [...this.slider.slides].findIndex(option => Number(option.dataset.year) >= gotToYear)
      link.addEventListener('click', () => this.hilightSlide(firstMachingSliderIndex))

    })
  }

  hilightSlide(index) {
    this.slider.slideTo(index)
    const currentSlide = this.slider.slides[index]

    currentSlide.classList.add("restart");
    currentSlide.offsetWidth
    currentSlide.classList.remove("restart");

  }

}



export default TimelineSlider
